import { WindowState } from '../state';

export function createMirrorFlipControls(state: WindowState): HTMLElement {
  const container = document.createElement('div');
  container.className = 'toggle-row';

  const mirrorBtn = document.createElement('button');
  mirrorBtn.type = 'button';
  mirrorBtn.className = 'toggle-btn';
  if (state.config.layout.mirrorLR) mirrorBtn.classList.add('active');
  mirrorBtn.textContent = 'Mirror L\u2194R';

  mirrorBtn.addEventListener('click', () => {
    const next = !state.config.layout.mirrorLR;
    state.setMirror(next);
    mirrorBtn.classList.toggle('active', next);
  });

  const flipBtn = document.createElement('button');
  flipBtn.type = 'button';
  flipBtn.className = 'toggle-btn';
  if (state.config.layout.flipTB) flipBtn.classList.add('active');
  flipBtn.textContent = 'Flip T\u2195B';

  flipBtn.addEventListener('click', () => {
    const next = !state.config.layout.flipTB;
    state.setFlip(next);
    flipBtn.classList.toggle('active', next);
  });

  container.appendChild(mirrorBtn);
  container.appendChild(flipBtn);
  return container;
}
